import type { SVGProps } from "react";
export default function SvgMessage(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-message-square-text-icon lucide-message-square-text"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
			<path d="M7 11h10" />
			<path d="M7 15h6" />
			<path d="M7 7h8" />
		</svg>
	);
}
